import axios from './index';

/**
 * Types
 */
import type { Response } from '@/dtos/common.dto';
import type { CreateRoleDto, QueryRoleDto, RoleDto, UpdateRoleDto } from '@/dtos/role.dto';

/**
 * APIs
 */
// 创建角色信息
export function cRole(data: CreateRoleDto) {
    return axios<Response<RoleDto>>('/v1/roles', {
        data,
        method: 'post',
    });
}

// 获取角色列表
export function roles(params?: QueryRoleDto) {
    return axios<Response<RoleDto[]>>('/v1/roles', {
        method: 'get',
        params,
    });
}

// 获取角色信息
export function rRole(id: string) {
    return axios<Response<RoleDto>>(`/v1/roles/${id}`, {
        method: 'get',
    });
}

// 编辑角色信息
export function uRole({ id, ...data }: { id: string } & UpdateRoleDto) {
    return axios<Response<RoleDto>>(`/v1/roles/${id}`, {
        data,
        method: 'patch',
    });
}

// 删除角色信息
export function dRole(id: string) {
    return axios<Response>(`/v1/roles/${id}`, {
        method: 'delete',
    });
}
